const DocEvents = {
	updateProducts: 'update_products',
	loadError: 'load_error',
};

export default DocEvents;
